import { render } from "./WaaromsteunenTwa.vue?vue&type=template&id=044d8e6d&scoped=true"
import script from "./WaaromsteunenTwa.vue?vue&type=script&lang=js"
export * from "./WaaromsteunenTwa.vue?vue&type=script&lang=js"

import "./WaaromsteunenTwa.vue?vue&type=style&index=0&id=044d8e6d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044d8e6d"]])

export default __exports__